import { EntityLayoutContextProvider } from "./EntityLayoutContext";
import { EntityLayoutUiImmersive } from "./EntityLayoutUiImmersive";

export const EntityLayoutImmersive = () => {
  return (
    <EntityLayoutContextProvider>
      <EntityLayoutUiImmersive />
    </EntityLayoutContextProvider>
  );
};
